var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLaboratoryResultIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 1h7v1.5H6v10a2.5 2.5 0 1 1-5 0v-10H0V1Zm2.5 1.5V8h2V2.5h-2ZM9 1h7v1.5h-1v10a2.5 2.5 0 1 1-5 0v-10H9V1Zm2.5 1.5V8h2V2.5h-2Z"
})));
export default SvgLaboratoryResultIcon;